export default __webpack_public_path__ + "static/media/DSC02200.88fc32ea.jpg";